import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
//import useUser from "../../../js/utils/useUser";
import ChannelConnection from "../../../js/connection/ChannelConnection";
import {v4 as uuidv4} from 'uuid';

export default function useChannelValidation(connection: ChannelConnection) {
    //const { user } = useUser();
    const params = useParams();
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>();
    const myuuid = uuidv4().replace(/-/g, '');

    useEffect(() => {
        setLoading(true);

        // if (!user) {
        //     return;
        // }

        if (!params.id) {
            return;
        }
        
        const code = "";//searchParams.get("code") || undefined;
        connection.connectToChannel(params.id!, {uid:myuuid, email:""}, code);
        setError("");
        setLoading(false);
        // (async () => {
            // try {
                // const code = "";//searchParams.get("code") || undefined;
                // await connection.connectToChannel(params.id!, {uid:"1",email:""}, code);
                // setError("");
                // setLoading(false);
            // } catch (error: any) {
            //     console.error("INJAAAAA:",error);
            //     setError(error.message);
            //     setLoading(false);
            // }
        // })();
    }, [{uid:myuuid,email:""}, params.id, searchParams, connection]);

    return { loading, error };
}
